import { html, ref } from '@microsoft/fast-element';
import type { TimerBar } from './timer-bar';
import { timerIcon } from '../../../styles';
export const TimerBarTemplate = html<TimerBar>`
  <div class="timer-bar">
    <div class="timer-bar-background" ${ref('regressiveBarBackground')}>
      <div class="timer-bar-foreground" ${ref('regressiveBarForeground')}></div>
    </div>
    <div class="timer-bar-icon">${timerIcon('start', '#C7FF8C')}</div>
    <span class="timer-bar-hhmmss">${(x) => x.timeRemaining}</span>
  </div>
`;
